// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const carbink: PokeData = {
  "id": 703,
  "name": "carbink",
  "height": 3,
  "weight": 57,
  "base_experience": 100,
  "types": [
    PokeType.ROCK,
    PokeType.FAIRY
  ],
  "api_moves": [
    "tackle",
    "rock-throw",
    "harden",
    "light-screen",
    "reflect",
    "rock-slide",
    "sharpen",
    "flail",
    "safeguard",
    "ancient-power",
    "skill-swap",
    "rock-polish",
    "power-gem",
    "stone-edge",
    "stealth-rock",
    "guard-split",
    "smack-down",
    "moonblast"
  ],
  "moves": [
    "tackle",
    "rock-throw",
    "reflect",
    "rock-slide",
    "ancient-power",
    "stealth-rock",
    "moonblast",
    "play-rough",
    "heal-bell",
    "misty-terrain",
    "rock-smash",
    "rock-blast",
    "seismic-toss"
  ],
  "evolution_chain": {
    "id": 361,
    "item": null,
    "species": [
      {
        "name": "carbink",
        "order": 703,
        "types": [
          PokeType.ROCK,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 200,
    "speed": 100,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
